var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      staticClass: "middle",
      attrs: {
        btnUnuse: !_vm.isHaveBalance,
        showMask: true,
        singleBtn: true,
        closeIcon: true,
        title: _vm.$t("tradeTxPairManage.openTxPairConfirm.title", {
          symbol: _vm.txPair.symbol
        }),
        leftBtnTxt: _vm.$t("tradeTxPairManage.openTxPairConfirm.btn"),
        leftBtnClick: _vm.trans,
        close: _vm.close
      }
    },
    [
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.$t("dexBalance")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
          _c("img", {
            staticClass: "__icon",
            attrs: { src: _vm.viteTokenInfo.icon }
          }),
          _vm._v(
            "\n            " + _vm._s(_vm.viteTokenInfo.tokenSymbol) + " "
          ),
          _c("span", { staticClass: "__right" }, [
            _vm._v(_vm._s(_vm.showExViteBalance))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("tradeTxPairManage.openTxPairConfirm.fee")) +
              "\n            "
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isHaveBalance,
                  expression: "!isHaveBalance"
                }
              ],
              staticClass: "__err"
            },
            [_vm._v(_vm._s(_vm.$t("hint.insufficientBalance")))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input" }, [
          _vm._v(_vm._s(_vm.spend) + " dSLS")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__hint" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("tradeTxPairManage.openTxPairConfirm.hint")))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }